import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Moment from "react-moment";

const MentorMiniStream = ({
  course: {
    _id,
    channelid,
    courseposter,
    avatar,
    coursetitle,
    firstname,
    lastname,
    location: { city, state },
    jobtitle,
    date,
  },
}) => {
  let myString = coursetitle;
  let trimmedString = myString.trim();
  let formattedString = trimmedString.replace(/\s+/g, "-");

  return (
    <Fragment>
      <Link
        to={`/liveonime/mentors/courses/${channelid}/${formattedString}/${_id}`}
      >
        <div className="content-container">
          <div className="stream-result">
            {/* <div className="stream-video">
                  <div className="video-overlay">
                    <div className="stream-live red">
                      <i className="fas fa-circle mx-5"></i>
                      Live
                    </div>
                    <div className="stream-live red">
                      <i className="fas fa-graduation-cap fa-lg mx-5"></i>
                    </div>
                    <div className="stream-viewers white">
                      <i className="fas fa-user mx-5"></i>
                      92.2k
                    </div>
                    <div className="stream-length red">00:00:00</div>
                  </div>
                </div> */}
            <img
              className="stream-media"
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/course_posters/${courseposter}`}
            />
            <div className="stream-info-container">
              <div className="result-avi-container">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="result-avi"
                />
              </div>
              <div className="stream-info-items">
                <p className="result-stream-description">{coursetitle}</p>
                <ul className="result-stream-items">
                  <li className="stream-item red bold">{channelid}</li>
                  <li className="stream-item">
                    <i className="far fa-clock mr-5 red"></i>
                    <Moment format="MM/DD/YYYY">{date}</Moment>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="stream-item-type red">Course</div>
        </div>
      </Link>
    </Fragment>
  );
};

MentorMiniStream.propTypes = {
  course: PropTypes.object.isRequired,
};

export default connect()(MentorMiniStream);
